(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["de-main-collection"] && !Shopify.designMode) return;
  try {
    
  // Hide the facet sidebar on small screens until the Filters button opens it.
  (function () {
    const side = document.getElementById('de-facets');
    if (!side) return;
    const mq = window.matchMedia('(max-width: 1023px)');
    const apply = () => { side.hidden = mq.matches && document.querySelector('[data-de-facets-toggle]')?.getAttribute('aria-expanded') !== 'true'; };
    apply();
    mq.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["de-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-de-related]').forEach((wrap) => {
      if (wrap.children.length > 0) return;
      fetch(wrap.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-de-related]');
          if (fresh && fresh.children.length > 0) wrap.innerHTML = fresh.innerHTML;
          else wrap.remove();
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
